var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFolder = function SvgIcFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 105 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2276A6",
    d: "M72.397 3.36C72.941 1.793 74.51.704 76.143.704h25.614c1.953 0 3.33 1.537 3.105 3.426l-6.595 55.582c-.224 1.889-1.985 3.425-3.938 3.425H13.005c-1.953 0-3.33-1.536-3.105-3.425l5.57-46.681c.225-1.89 1.986-3.426 3.939-3.426h44.247c3.81 0 7.46-2.593 8.741-6.243Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0EFEF",
    d: "M11.374 60.576h84.974l4.834-57.15H16.209l-4.835 57.15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M11.374 60.576h84.974l3.49-57.15h-83.63l-4.834 57.15Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0EFEF",
    d: "M11.374 60.578h84.974L99.26 1.602H14.288l-2.914 58.976Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M11.374 60.578h84.974L97.5 1.602H14.288l-2.914 58.976Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0EFEF",
    d: "M11.374 60.576h84.974L96.86 0H11.886l-.512 60.576Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M11.373 60.575h84.974l-1.73-59.424H10.19l1.184 59.424Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0EFEF",
    d: "M11.374 60.578h84.974l-2.53-58.976H8.845l2.53 58.976Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M11.377 60.577H96.35l-4.002-58.08H7.375l4.002 58.08Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0EFEF",
    d: "M11.374 60.576h84.974L91.705 2.977H6.732l4.642 57.599Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#63B9E9",
    d: "M53.921 6.98c.064-1.6 1.249-2.72 2.913-2.72h25.614c1.953 0 3.842 1.568 4.195 3.521L96.76 59.65c.384 1.953-.897 3.522-2.818 3.522H12.62c-1.953 0-3.842-1.57-4.194-3.522L.068 16.874c-.384-1.953.897-3.522 2.818-3.522h44.247c3.842 0 6.66-2.625 6.788-6.371Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9E1F8",
    d: "M53.921 6.98c.064-1.6 1.249-2.72 2.913-2.72h25.614c1.953 0 3.842 1.568 4.195 3.521L96.76 59.65c.384 1.953-.897 3.522-2.818 3.522H12.62c-1.953 0-3.842-1.57-4.194-3.522L.068 16.874c-.384-1.953.897-3.522 2.818-3.522h44.247c3.842 0 6.66-2.625 6.788-6.371Z",
    opacity: 0.2
  })));
};
export default SvgIcFolder;